import { api } from './api';
import type {
  NotificationsResponse,
  NotificationResponse,
  UnreadCountResponse,
} from '../types/notification';

const NOTIFICATIONS_URL = '/notifications';

/**
 * Get all notifications with pagination
 */
export const getNotifications = async (params?: {
  unreadOnly?: boolean;
  type?: string;
  page?: number;
  limit?: number;
}): Promise<NotificationsResponse> => {
  const queryParams = new URLSearchParams();

  if (params) {
    if (params.unreadOnly) {
      queryParams.append('unreadOnly', 'true');
    }
    if (params.type) {
      queryParams.append('type', params.type);
    }
    if (params.page) {
      queryParams.append('page', params.page.toString());
    }
    if (params.limit) {
      queryParams.append('limit', params.limit.toString());
    }
  }

  const queryString = queryParams.toString();
  const url = queryString ? `${NOTIFICATIONS_URL}?${queryString}` : NOTIFICATIONS_URL;

  const response = await api.get<NotificationsResponse>(url);
  return response.data;
};

/**
 * Get unread notification count
 */
export const getUnreadCount = async (): Promise<UnreadCountResponse> => {
  const response = await api.get<UnreadCountResponse>(`${NOTIFICATIONS_URL}/unread-count`);
  return response.data;
};

/**
 * Mark a notification as read
 */
export const markAsRead = async (id: string): Promise<NotificationResponse> => {
  const response = await api.patch<NotificationResponse>(`${NOTIFICATIONS_URL}/${id}/read`);
  return response.data;
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async (): Promise<{ success: boolean; data: { message: string; modifiedCount: number } }> => {
  const response = await api.post(`${NOTIFICATIONS_URL}/mark-all-read`);
  return response.data;
};

/**
 * Delete a notification
 */
export const deleteNotification = async (id: string): Promise<{ success: boolean }> => {
  const response = await api.delete(`${NOTIFICATIONS_URL}/${id}`);
  return response.data;
};

/**
 * Clear all read notifications
 */
export const clearAllRead = async (): Promise<{ success: boolean; data: { message: string; deletedCount: number } }> => {
  const response = await api.delete(`${NOTIFICATIONS_URL}/clear-all`);
  return response.data;
};

export default {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  clearAllRead,
};
